// Approvals
export const tableColumns = {
  Session_Id: 'Session Id',
  Session_Name: 'Session Name',
  NoPeople: 'No. of Participants',
  Session_Status: 'Status',
  Session_Date: 'Session Date',
};

export const teamPerformanceTableColumns = {
  EmpName: 'Employee Name',
  Designation: 'Designation',
  ModifiedDate: 'Date',
  CurrentStage: 'Current Stage',
  Feedback_Date: 'Due Date',
  Overall_Rating_Manager: 'Overall Manager Rating',
  Overall_Rating_Calibration: 'Overall Calibration Rating',
};
